(function () {
  const ICON_SHOW =
    '<svg class="icon icon-eye" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.99999 2.25C13.044 2.25 16.4085 5.16 17.1142 9C16.4092 12.84 13.044 15.75 8.99999 15.75C4.95599 15.75 1.59149 12.84 0.885742 9C1.59074 5.16 4.95599 2.25 8.99999 2.25ZM8.99999 14.25C10.5296 14.2497 12.0138 13.7301 13.2096 12.7764C14.4055 11.8226 15.2422 10.4912 15.5827 9C15.2409 7.50998 14.4037 6.18 13.208 5.22752C12.0122 4.27504 10.5287 3.7564 8.99999 3.7564C7.47126 3.7564 5.98776 4.27504 4.79202 5.22752C3.59629 6.18 2.75907 7.50998 2.41724 9C2.75781 10.4912 3.5945 11.8226 4.79035 12.7764C5.9862 13.7301 7.47039 14.2497 8.99999 14.25ZM8.99999 12.375C8.10489 12.375 7.24644 12.0194 6.61351 11.3865C5.98057 10.7535 5.62499 9.89511 5.62499 9C5.62499 8.10489 5.98057 7.24645 6.61351 6.61351C7.24644 5.98058 8.10489 5.625 8.99999 5.625C9.8951 5.625 10.7535 5.98058 11.3865 6.61351C12.0194 7.24645 12.375 8.10489 12.375 9C12.375 9.89511 12.0194 10.7535 11.3865 11.3865C10.7535 12.0194 9.8951 12.375 8.99999 12.375Z" fill="currentColor"/></svg>';

  const ICON_HIDE =
    '<svg class="icon icon-eye-off" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M11.9603 12.9611C11.0704 13.4909 10.0459 13.7565 9.00002 13.7267C4.95602 13.7267 1.59152 10.8167 0.885773 6.97669C1.19216 5.31881 2.02871 3.80534 3.26852 2.66019M7.42502 5.42499C7.84431 5.00614 8.41209 4.7708 9.00417 4.75111C9.59626 4.73141 10.1697 4.92896 10.6165 5.30388C11.0633 5.6788 11.3559 6.20365 11.4372 6.7791M12.7275 10.4864C13.9673 9.34125 14.8079 7.82779 15.1143 6.16991C14.4085 2.32991 11.044 -0.580078 7.00002 -0.580078M0.750023 0.749991L17.25 17.25M7.36502 8.62249C7.72246 8.98003 8.20748 9.18099 8.71318 9.18116" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function resolveLabel(value, fallback) {
    if (typeof value !== 'string' || value === '' || value.indexOf('Translation missing') !== -1) {
      return fallback;
    }
    return value;
  }

  function labelShow() {
    return resolveLabel(window.showPasswordStrings && window.showPasswordStrings.show, 'Show password');
  }

  function labelHide() {
    return resolveLabel(window.showPasswordStrings && window.showPasswordStrings.hide, 'Hide password');
  }

  function enhance(input) {
    if (input.dataset.showPasswordReady === 'true') return;

    const field = input.closest('.field, .password-field');
    if (!field) return;

    input.dataset.showPasswordReady = 'true';
    field.classList.add('field--has-toggle');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'show-password-toggle';
    toggle.setAttribute('aria-label', labelShow());
    toggle.setAttribute('aria-pressed', 'false');
    toggle.innerHTML = ICON_SHOW;

    field.appendChild(toggle);

    toggle.addEventListener('click', function () {
      const reveal = input.type === 'password';
      input.type = reveal ? 'text' : 'password';
      toggle.setAttribute('aria-pressed', String(reveal));
      toggle.setAttribute('aria-label', reveal ? labelHide() : labelShow());
      toggle.innerHTML = reveal ? ICON_HIDE : ICON_SHOW;
    });
  }

  function init(root) {
    (root || document).querySelectorAll('input[type="password"]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-scan when Shopify's theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
